import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
  changePrimaryAddress
} from 'actions';

import CustomerAddressCard from 'components/Customer/CustomerAddressCard';
import ModalWrapper from 'components/Modals/ModalWrapper';
import ConfirmModal from 'components/Modals/ConfirmModal';

const CustomerAddressesModal = ({
  title,
  isShown,
  onConfirm,
  addresses,
  cardClassName,
  showActions
}) => {
  const dispatch = useDispatch();
  const [confirmShown, setConfirmShown] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const jurisdictions = useSelector(state => state.common?.jurisdictions ?? []);
  const isChangingPrimaryAddress = useSelector(state => state.customer.isChangingPrimaryAddress);

  const openModal = (address) => {
    setConfirmShown(true);
    setSelectedAddress(address);
  };

  const closeModal = () => {
    setConfirmShown(false);
    setSelectedAddress(null);
  };

  const onConfirmAddress = () => {
    dispatch(changePrimaryAddress(selectedAddress.customerId, selectedAddress.id));
    setConfirmShown(false);
    setSelectedAddress(null);
  };

  return (<ModalWrapper
    modalSize="customer-addresses-modal"
    headerClose={ false }
    isOpen={ isShown }
    title={ title }
    btnConfirmTitle="Close"
    showCancel={ false }
    onConfirm={ () => onConfirm() }
  >
    { (!addresses || addresses.length === 0) && <p>No Addresses</p> }
    { addresses.length > 0 && <div className="customer-addresses">
      { addresses.filter(x => x.source === 2) && <div className="columns">
        <p className="column col-12"><strong>From Forms:</strong></p>
        { addresses.filter(x => x.source === 2).map(x => <div className="column col-6" key={ x.id }>
          <CustomerAddressCard
            className={ cardClassName }
            address={ x }
            jurisdictions={ jurisdictions }
            showActions={ showActions }
            onMakePrimary={ address => openModal(address) }
          />
        </div>)}
      </div> }
      { addresses.filter(x => x.source === 1).length > 0 && <div className="columns">
        <p className="column col-12"><strong>From Books & Records:</strong></p>
        { addresses.filter(x => x.source === 1).map(x => <div className="column col-6" key={ x.id }>
          <CustomerAddressCard
            className={ cardClassName }
            address={ x }
            jurisdictions={ jurisdictions }
            showActions={ showActions }
            onMakePrimary={ address => openModal(address) }
          />
        </div>)}
      </div> }
      { showActions && <ConfirmModal
        key="switchPrimaryAddress"
        isShown={ confirmShown }
        isPerformingAction={ isChangingPrimaryAddress }
        onConfirm={ () => onConfirmAddress() }
        onCancel={ () => closeModal() }
        title="Switch Primary Mailing Address"
        message="Are you sure you want to switch the Primary Mailing Address?"
      >
        <p>The Primary Mailing Address is used for the Prepopulation of Form Data and Data Exports.</p>
      </ConfirmModal> }
    </div>}
  </ModalWrapper>);
};

CustomerAddressesModal.propTypes = {
  title: PropTypes.string,
  isShown: PropTypes.bool,
  onConfirm: PropTypes.func,
  addresses: PropTypes.arrayOf(PropTypes.shape),
  cardClassName: PropTypes.string,
  showActions: PropTypes.bool
};

CustomerAddressesModal.defaultProps = {
  title: 'Customer Addresses',
  isShown: false,
  onConfirm: () => {},
  addresses: null,
  cardClassName: null,
  showActions: false
};

export default CustomerAddressesModal;
